module.exports = __webpack_public_path__ + "static/media/how-it-works-golf-step-3.39ec00c5.png";